"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDoctorModuleData = void 0;
var graphql_request_1 = require("graphql-request");
var shopify_1 = require("../shopify-graphql/shopify");
var getDoctorModuleFragment = function (pathType) {
    return "\n  fragment doctorModuleValues on ".concat(pathType, " {\n    metafield(key: \"doctor_module_data\", namespace: \"global\") {\n      reference {\n        ... on Metaobject {\n          field(key: \"data\") {\n            value\n          }\n        }\n      }\n    }\n  }\n  ");
};
var getDoctorModuleData = function (handle, pathType) { return __awaiter(void 0, void 0, void 0, function () {
    var variables, query, data, reference;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                variables = {
                    handle: handle,
                };
                query = (0, graphql_request_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query getDoctorModuleDataFrom", "($handle: String!) {\n      data:", "(handle: $handle) {\n          ...doctorModuleValues\n      }\n    }\n\n    ", "\n    "], ["\n    query getDoctorModuleDataFrom", "($handle: String!) {\n      data:", "(handle: $handle) {\n          ...doctorModuleValues\n      }\n    }\n\n    ", "\n    "])), pathType, pathType.toLowerCase(), getDoctorModuleFragment(pathType));
                return [4 /*yield*/, (0, shopify_1.default)(query, variables)];
            case 1:
                data = (_c.sent()).data;
                if (!((_a = data.metafield) === null || _a === void 0 ? void 0 : _a.reference)) {
                    console.error("Shopify Metafield Error: provided page|collection|product is missing 'doctor_module_data' metafield in Shopify admin.", 'page|collection|product: ', data);
                    throw new Error('');
                }
                reference = data.metafield.reference;
                if (!((_b = reference.field) === null || _b === void 0 ? void 0 : _b.value)) {
                    return [2 /*return*/, null];
                }
                return [2 /*return*/, JSON.parse(reference.field.value)];
        }
    });
}); };
exports.getDoctorModuleData = getDoctorModuleData;
var templateObject_1;
